import { BoxProps, Box } from "@mui/material";

export const Center = (props: BoxProps) => (
    <Box
        sx={{ display: "flex", justifyContent: "center", alignContent: "center", alignItems: "center", margin: "auto", height: "100%" }}
        {...props}
    />
);
